import { useEffect, useState } from "react";
import { ILearning } from "@kunduz/data-access-learning-api";
import styles from "./learningAdaptiveTestContent.module.scss";
import { LearningAdaptiveTestGoToPublisher } from "../adaptiveTestGoToPublisher/learningAdaptiveTestGoToPublisher";
import { LearningAdaptiveTestChoice } from "../adaptiveTestChoice/learningAdaptiveTestChoice";
import { LearningAdaptiveTestFooter } from "../adaptiveTestFooter/learningAdaptiveTestFooter";

enum AnswerType {
  VIDEO = "video",
  IMAGE = "image",
  NONE = "none",
}

export const LearningAdaptiveTestContent = (props: Props) => {
  const {
    answer,
    isMobile,
    question,
    validChoices,
    correctChoice,
    publisher,
    type,
    adaptiveTestMutate,
    setTestInfo,
    submitAnswerAdaptiveQuestion,
    conceptId,
    conceptName,
    courseId,
    courseName,
    moduleId,
    moduleName,
    questionId,
    taxonmy,
    testOrder,
    setTestOrder,
    setScreenState,
    extendedMe,
    onAnswerResultScreenVisited,
    onAnswerViewed,
    onCheckAnswered,
    onContinueButtonClicked,
    onItemViewed,
    onPublisherClicked,
    answerCheckButtonLabel,
    answerButtonLabel,
    continueButtonLabel,
    correctChoiceMessage,
    correctMessage,
    playbackSpeedBuildLabel,
    settingsLabel,
    viewAnswerPopupTitle,
    wrongMessage,
    publisherText,
    handleVideoEnded,
  } = props;
  const [selectedChoice, setSelectedChoice] = useState<number | undefined>(
    undefined,
  );
  const [isCorrect, setIsCorrect] = useState(false);
  const [isVisibleFooter, setIsVisibleFooter] = useState(false);
  const correctChoiceLabel =
    validChoices.find((v) => correctChoice === v.value)?.name || "";

  const onSelectOption = (choice: number) => {
    setSelectedChoice(choice);
    setScreenState("answer_selected");
  };

  const checkAnswerType = () => {
    if (!answer) {
      return AnswerType.NONE;
    }

    return answer.is_video ? AnswerType.VIDEO : AnswerType.IMAGE;
  };

  const onCheckAnswer = () => {
    setIsCorrect(selectedChoice === correctChoice);
    setIsVisibleFooter(true);
    setTestInfo((prevState: any) => ({
      ...prevState,
      ...(selectedChoice === correctChoice
        ? { correctCount: prevState.correctCount + 1 }
        : { wrongCount: prevState.wrongCount + 1 }),
    }));
    submitAnswerAdaptiveQuestion(selectedChoice);
    setScreenState("answer_result");
    const payload = {
      entrypoint: type,
      student_id: extendedMe.id,
      course_id: courseId,
      course_name: courseName,
      module_name: moduleName,
      module_id: moduleId,
      concept_name: conceptName,
      concept_id: conceptId,
      textbook_question_id: questionId,
      taxonomy_name: taxonmy.name,
      is_sponsored: !!publisher,
      publisher_name: publisher?.name,
      item_order: testOrder,
    };
    onCheckAnswered(payload);
  };

  useEffect(() => {
    const payload = {
      entrypoint: type,
      student_id: extendedMe.id,
      course_id: courseId,
      course_name: courseName,
      module_name: moduleName,
      module_id: moduleId,
      concept_name: conceptName,
      concept_id: conceptId,
      textbook_question_id: questionId,
      taxonomy_name: taxonmy.name,
      is_sponsored: !!publisher,
      publisher_name: publisher?.name,
      item_order: testOrder,
    };
    onItemViewed(payload);
  }, [testOrder]);

  const handleAnswerResultScreenVisited = () => {
    const payload = {
      entrypoint: type,
      student_id: extendedMe.id,
      course_id: courseId,
      course_name: courseName,
      module_name: moduleName,
      module_id: moduleId,
      concept_name: conceptName,
      concept_id: conceptId,
      textbook_question_id: questionId,
      taxonomy_name: taxonmy.name,
      is_sponsored: !!publisher,
      publisher_name: publisher?.name,
      item_order: testOrder,
      is_correct: isCorrect,
      answer_type: checkAnswerType(),
    };

    onAnswerResultScreenVisited(payload);
  };

  const handleContinueClicked = () => {
    const payload = {
      entrypoint: type,
      student_id: extendedMe.id,
      course_id: courseId,
      course_name: courseName,
      module_name: moduleName,
      module_id: moduleId,
      concept_name: conceptName,
      concept_id: conceptId,
      textbook_question_id: questionId,
      taxonomy_name: taxonmy.name,
      is_sponsored: !!publisher,
      publisher_name: publisher?.name,
      item_order: testOrder,
      is_correct: isCorrect,
      answer_type: checkAnswerType(),
    };

    onContinueButtonClicked(payload);
  };
  const handleAnswerViewed = () => {
    const payload = {
      entrypoint: type,
      student_id: extendedMe.id,
      course_id: courseId,
      course_name: courseName,
      module_name: moduleName,
      module_id: moduleId,
      concept_name: conceptName,
      concept_id: conceptId,
      textbook_question_id: questionId,
      taxonomy_name: taxonmy.name,
      is_sponsored: !!publisher,
      publisher_name: publisher?.name,
      item_order: testOrder,
      is_correct: isCorrect,
      answer_type: checkAnswerType(),
    };

    onAnswerViewed(payload);
  };

  const handlePublisherClicked = () => {
    const payload = {
      entrypoint: type,
      student_id: extendedMe.id,
      course_id: courseId,
      course_name: courseName,
      module_name: moduleName,
      module_id: moduleId,
      concept_name: conceptName,
      concept_id: conceptId,
      textbook_question_id: questionId,
      publisher_name: publisher?.name,
      item_order: testOrder,
    };

    onPublisherClicked(payload);
  };

  return (
    <div className={styles["container"]}>
      <div>
        <LearningAdaptiveTestGoToPublisher
          name={publisher?.name}
          img={publisher?.logo}
          isSponsored={publisher?.is_sponsored}
          destinationUrl={publisher?.destination_url}
          onPublisherClicked={handlePublisherClicked}
          publisherText={publisherText}
        />
        <div className={styles["questionImg"]}>
          <img
            style={{
              borderTopLeftRadius: !publisher ? 16 : 0,
              borderTopRightRadius: !publisher ? 16 : 0,
            }}
            src={question}
            alt="question"
            loading="lazy"
          />
        </div>
      </div>
      {!isVisibleFooter ? (
        <div className={styles["formContainer"]}>
          {validChoices.length > 0 && (
            <div className={styles["optionsContainer"]}>
              {validChoices.map((choice) => (
                <LearningAdaptiveTestChoice
                  key={choice.value}
                  label={choice.name}
                  onClick={() => onSelectOption(choice.value)}
                  isActive={choice.value === selectedChoice}
                />
              ))}
            </div>
          )}
          <button
            onClick={onCheckAnswer}
            disabled={!selectedChoice}
            className={styles["button"]}
          >
            {answerCheckButtonLabel}
          </button>
        </div>
      ) : (
        <LearningAdaptiveTestFooter
          isMobile={isMobile}
          isCorrect={isCorrect}
          answer={answer}
          correctChoiceLabel={correctChoiceLabel}
          adaptiveTestMutate={adaptiveTestMutate}
          setTestOrder={setTestOrder}
          testOrder={testOrder}
          onAnswerResultScreenVisited={handleAnswerResultScreenVisited}
          onContinueButtonClicked={handleContinueClicked}
          onAnswerViewed={handleAnswerViewed}
          setScreenState={setScreenState}
          playbackSpeedBuildLabel={playbackSpeedBuildLabel}
          settingsLabel={settingsLabel}
          answerButtonLabel={answerButtonLabel}
          continueButtonLabel={continueButtonLabel}
          correctChoiceMessage={correctChoiceMessage}
          viewAnswerPopupTitle={viewAnswerPopupTitle}
          correctMessage={correctMessage}
          wrongMessage={wrongMessage}
          handleVideoEnded={handleVideoEnded}
        />
      )}
    </div>
  );
};

interface Props {
  questionId: number;
  question: string;
  answer: ILearning.LearningAdaptiveTestAnswer;
  isMobile: boolean;
  validChoices: ILearning.LearningChoice[];
  correctChoice: number;
  publisher: ILearning.LearningAdaptiveTestPublisher;
  adaptiveTestMutate: () => void;
  submitAnswerAdaptiveQuestion: (v: number | undefined) => void;
  setTestInfo: (v: any) => void;
  type: string;
  courseId: number;
  courseName: string;
  moduleName: string;
  moduleId: number;
  conceptName: string;
  conceptId: number;
  taxonmy: ILearning.LearningAdaptiveTestTaxonomy;
  testOrder: number;
  setTestOrder: (e: number) => void;
  setScreenState: (e: "question" | "answer_selected" | "answer_result") => void;
  extendedMe: any;
  onCheckAnswered: (payload: any) => void;
  onItemViewed: (payload: any) => void;
  onAnswerResultScreenVisited: (payload: any) => void;
  onContinueButtonClicked: (payload: any) => void;
  onAnswerViewed: (payload: any) => void;
  onPublisherClicked: (payload: any) => void;
  answerCheckButtonLabel: string;
  playbackSpeedBuildLabel: string;
  settingsLabel: string;
  answerButtonLabel: string;
  continueButtonLabel: string;
  correctChoiceMessage: string;
  viewAnswerPopupTitle: string;
  correctMessage: string;
  wrongMessage: string;
  publisherText: string;
  handleVideoEnded?: () => void;
}
